import Language from "@/enums/Language";
import messages from "@/i18n";
import ISystemSetting from "@/interfaces/SliceType/ISystemSetting";
import { RootState } from "@/redux/store";
import { getLocalStore, setLocalStore } from "@/utils/Session";
import { PayloadAction, createSlice } from "@reduxjs/toolkit";

export const languageSlice = createSlice({
  name: "language",
  initialState: {
    language: Language.zh_TW,
    messages: messages[Language.zh_TW],
  },
  reducers: {
    setLanguage(state, action: PayloadAction<Language>) {
      const setting = getLocalStore("setting") as ISystemSetting;
      setLocalStore("setting", { ...setting, language: action.payload });
      state.language = action.payload;
      state.messages = messages[action.payload];
    },
  },
});

export const { setLanguage } = languageSlice.actions;

export const selectLanguage = (state: RootState) => state.language;

export default languageSlice.reducer;
